











import { Component, Vue } from 'vue-property-decorator';
import FooterNav from './FooterNav.vue';
import TermsOfServiceDialog from '../TermsOfService/TermsOfServiceDialog.vue';
import NoticeDialog from '../Commons/NoticeDialog.vue';

@Component({
    components: {
        FooterNav,
        TermsOfServiceDialog,
        NoticeDialog
    },
})
export default class MainTemplate extends Vue { }
